module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Rm7MF"))).then(() => parcelRequire('ljYL6'));